import Analytics from 'analytics-opencare';
import React, { useEffect } from 'react';

import SingleSelect from 'pages/common/components/SingleSelect/SingleSelect';
import { OptionBlock, Title } from 'pages/common/styled-components';
import { SPECIALTY_FLOW } from 'pages/funnel/specialtyFlow/config';
import { useFunnelStorage } from 'pages/funnel/storage/Storage';
import { StepWrapper } from 'pages/funnel/styled-components';
import { generateStepAnalytics, STEP_KEY } from 'pages/funnel/utils';
import { useAnalyticsService } from 'services/AnalyticsService';

import {
  SPECIALIST_IDS,
  SPECIALIST_TYPES,
} from '../../specialtyFlow/funnelConstants';
import { FunnelStepPropTypes } from '../common/types';

const analytics = new Analytics();

const SpecialistType = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-type',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const submitAnswer = (selectedOption, index) => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_specialist-type',
      name: 'wizard',
      section: 'specialist-type',
      ...generateStepAnalytics(index, storage, {
        response: selectedOption.title,
      }),
    });

    const selectedGeneralDentist =
      selectedOption.id === SPECIALIST_IDS.GENERAL_DENTIST;

    storage.save(
      STEP_KEY.SPECIALIST_TYPE,
      {
        specialistTypes: [{ id: selectedOption.id, dbId: selectedOption.dbId }],
      },
      // Mark step as incomplete if general dentist is selected, so we don't skip over it if we come back here
      !selectedGeneralDentist,
    );

    if (selectedGeneralDentist) {
      moveToNextStep({ switchBranch: SPECIALTY_FLOW.BRANCHES.NEW_DENTIST });
      return;
    }

    moveToNextStep();
  };

  return (
    <div>
      <Title id="title">What type of specialist are you looking for?</Title>
      <StepWrapper>
        <form>
          <OptionBlock row={3}>
            {SPECIALIST_TYPES.map((option, i) => (
              <SingleSelect
                name={option.id}
                key={option.id}
                id={option.id}
                title={option.title}
                tooltip={option.description}
                describedBy="title"
                onChange={() => submitAnswer(option, i)}
              />
            ))}
          </OptionBlock>
        </form>
      </StepWrapper>
    </div>
  );
};

SpecialistType.propTypes = FunnelStepPropTypes;

export default SpecialistType;
